import styled from 'styled-components';
import { ERROR_DOTS_BG } from '../../Assets/images';

export const ErrorPageStyled = styled.div`
  .errorContent {
    width: 100%;
    margin-top: 121px;
    height: calc(100vh - 121px);
    background: url(${ERROR_DOTS_BG.src}) right center no-repeat, url(${ERROR_DOTS_BG.src}) left center no-repeat,
      ${(props) => props.theme.ErrorPage.bgColor};

    &.went_wrong {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-top: 0;
      height: 100vh;
      background: url(${ERROR_DOTS_BG.src}) right center no-repeat, url(${ERROR_DOTS_BG.src}) left center no-repeat,
        ${(props) => props.theme.color.white};
    }
    .tryAgainBtn {
      padding: 1rem 3rem;
      margin-right: 1rem;
      margin-bottom: 1rem;
    }
    .goToHomeBtn {
      padding: 1rem 3rem;
      margin-bottom: 1rem;
      margin-right: 0;
    }
    .font_20 {
      margin-top: 30px;
      color: ${(props) => props.theme.ErrorPage.blue};
      font-size: 20px;
      line-height: 30px;
      font-weight: 700;
    }
    .contact-link {
      a {
        color: ${(props) => props.theme.ErrorPage.green};
        font-size: 20px;
        line-height: 30px;
        font-weight: 700;
        text-decoration: underline;
      }
    }
  }
  @media (max-width: 480px) {
    .errorContent {
      background: ${(props) => props.theme.ErrorPage.bgColor};
      margin-top: 130px;
      &.went_wrong {
        background: ${(props) => props.theme.color.white};
      }
      .tryAgainBtn {
        margin-right: 0;
        width: 65%;
      }
      .goToHomeBtn {
        width: 65%;
      }
    }
  }
`;
